module.exports = __webpack_public_path__ + "static/media/20ECE6.6e759e02.jpg";